import { Col, Row, Timeline, Tooltip, Typography } from 'antd';
import {
  // ORDER_CANCEL_REASONS,
  SELLER_ORDER_STATUS_CONST,
} from 'constants/constants';
import { orderBy } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';
import { formatDateTime } from 'utils/formattedString';
import { CardWrapper } from './styles';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTrash } from '@fortawesome/pro-solid-svg-icons';
// import { useDispatch } from '@redux';
// import { comment } from '@redux/orders/actions';
// import { getAllOrderReturnHistories } from '@redux/orderReturnHistories/actions';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import crudSelectors from '@redux/crudSelectors';
import { useSelector } from '@redux';

const getStatusText = ({ item }) => {
  return item?.text;
};

const getShippingType = (shippingType, type = 'INTERNAL') => {
  if (['in3Days', 'in1Day', 'in2h'].includes(shippingType))
    return `orders.shippingType.${shippingType}`;
  return type === 'EXTERNAL' ? 'Other' : shippingType;
};

const OrderHistories = () => {
  const { t } = useTranslation();

  const data = useSelector<DynamicObjectType>(
    crudSelectors.orderHistories.getDataRecordArr,
  );

  const handleShowComment = (data) => {
    if (!!data?.newData || !!data?.oldData) {
      if (data?.newData?.shippingCarrier || data?.oldData?.shippingCarrier) {
        return (
          <>
            <>{`${data.creator?.firstName || ''} ${data.creator?.lastName || ''}: ${'Refresh order'}`}</>
            <Row>
              <Col span={11}>
                <div className="flex items-center">
                  <div className="font-semibold">Delivery type:&nbsp;</div>
                  <div className="text-secondary">
                    {data?.oldData?.deliveryType}
                  </div>
                </div>
              </Col>
              <Col span={2}>
                <FontAwesomeIcon icon={faArrowRight} />
              </Col>
              <Col span={11}>
                <div className="flex items-center">
                  <div className="font-semibold">Delivery type:&nbsp;</div>
                  <div className="text-secondary">
                    {data?.newData?.deliveryType}
                  </div>
                </div>
              </Col>
              <Col span={11}>
                {data?.oldData?.deliveryType === 'INTERNAL' && (
                  <div className="flex items-center">
                    <div className="font-semibold">Delivery Method:&nbsp;</div>
                    <div className="text-secondary">
                      {t(
                        getShippingType(
                          data?.oldData?.shippingType,
                          data?.oldData?.deliveryType,
                        ),
                      )}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={2}>
                <FontAwesomeIcon icon={faArrowRight} />
              </Col>
              <Col span={11}>
                {data?.newData?.deliveryType === 'INTERNAL' && (
                  <div className="flex items-center">
                    <div className="font-semibold">Delivery Method:&nbsp;</div>
                    <div className="text-secondary">
                      {t(
                        getShippingType(
                          data?.newData?.shippingType,
                          data?.newData?.deliveryType,
                        ),
                      )}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={11}>
                <div className="flex items-center">
                  <div className="font-semibold">Warehouse:&nbsp;</div>
                  <div className="text-secondary">
                    {t(getShippingType(data?.oldData?.locationId))}
                  </div>
                </div>
              </Col>
              <Col span={2}>
                <FontAwesomeIcon icon={faArrowRight} />
              </Col>
              <Col span={11}>
                <div className="flex items-center">
                  <div className="font-semibold">Warehouse:&nbsp;</div>
                  <div className="text-secondary">
                    {t(getShippingType(data?.newData?.locationId))}
                  </div>
                </div>
              </Col>
              <Col span={11}>
                {data?.oldData?.deliveryType === 'INTERNAL' && (
                  <div className="flex items-center">
                    <div className="font-semibold">Delivery partner:&nbsp;</div>
                    <div className="text-secondary">
                      {t(
                        getShippingType(
                          data?.oldData?.shippingCarrier || data?.oldData?.name,
                        ),
                      )}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={2}>
                <FontAwesomeIcon icon={faArrowRight} />
              </Col>
              <Col span={11}>
                {data?.newData?.deliveryType === 'INTERNAL' && (
                  <div className="flex items-center">
                    <div className="font-semibold">Delivery partner:&nbsp;</div>
                    <div className="text-secondary">
                      {t(
                        getShippingType(
                          data?.newData?.shippingCarrier || data?.newData?.name,
                        ),
                      )}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={11}>
                {data?.oldData?.deliveryType === 'EXTERNAL' && (
                  <div className="flex items-center">
                    <div className="font-semibold">Delivery note:&nbsp;</div>
                    <div className="text-secondary">
                      {data?.oldData?.deliveryNote}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={2}></Col>
              <Col span={11}>
                {data?.newData?.deliveryType === 'EXTERNAL' && (
                  <div className="flex items-center">
                    <div className="font-semibold">Delivery note:&nbsp;</div>
                    <div className="text-secondary">
                      {data?.newData?.deliveryNote}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </>
        );
      }
      if (data?.newData?.sku || data?.oldData?.sku) {
        return (
          <>
            <>{`${data.creator?.firstName || ''} ${data.creator?.lastName || ''}: ${'Replace SKU'}`}</>
            <Row>
              <Col span={11}>
                <div className="flex items-center">
                  <div className="">SKU:&nbsp;</div>
                  <div className="">{data?.oldData?.sku}</div>
                </div>
              </Col>
              <Col span={2}>
                <FontAwesomeIcon icon={faArrowRight} />
              </Col>
              <Col span={11}>
                <div className="flex items-center">
                  <div className="">SKU:&nbsp;</div>
                  <div className="">{data?.newData?.sku}</div>
                </div>
              </Col>
            </Row>
          </>
        );
      }
    } else {
      return (
        <Tooltip title={`${data?.comment || ''}`} placement="topLeft">
          <Typography.Paragraph ellipsis={{ rows: 2 }}>
            {`${data.creator?.firstName || ''} ${data.creator?.lastName || ''}: ${data?.comment || ''}`}
          </Typography.Paragraph>
        </Tooltip>
      );
    }
  };

  const getHistories = () => {
    return orderBy(data, ['createdAt'], ['desc'])?.map((e) => {
      const currentStatus = SELLER_ORDER_STATUS_CONST[e.status];
      return {
        // label: formatDateTime(e.createdAt),
        children: (
          <div>
            <div className="time-point">{formatDateTime(e.createdAt)}</div>
            <div className="font-semibold">
              {t(getStatusText({ item: currentStatus }))}
            </div>
            <div
              className={`${e?.creatorId ? '' : 'text-secondary'} mt-[10px]`}
            >
              {e?.creatorId ? (
                handleShowComment(e)
              ) : (
                <Tooltip title={e?.comment || ''} placement="topLeft">
                  <Typography.Paragraph
                    ellipsis={{ rows: 2 }}
                    className="text-secondary"
                  >
                    {e?.comment || ''}
                  </Typography.Paragraph>
                </Tooltip>
              )}
              <div className="mt-1">
                {e?.note ? <>Note: {e?.note}</> : null}
              </div>
            </div>
          </div>
        ),
      };
    });
  };

  return (
    <CardWrapper title="Histories">
      <div className="w-full">
        {/* <Form form={form} onFinish={onSubmit}>
          <div className="d-flex w-full mt-[10px]">
            <Form.Item name="comment" noStyle>
              <Input
                placeholder="Add comment"
                suffix={
                  <Button htmlType="submit" type="primary">
                    {t('button.add')}
                  </Button>
                }
              />
            </Form.Item>
          </div>
        </Form> */}
        <div className="mt-[30px]">
          <TimelineStyles
            className="mt-[40px]"
            mode="left"
            items={getHistories()}
          ></TimelineStyles>
        </div>
      </div>
    </CardWrapper>
  );
};

const TimelineStyles = styled(Timeline)`
  padding-left: 150px;

  .time-point {
    position: absolute;
    left: -160px;
  }
`;

export default OrderHistories;
